import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import http from "../lib/http";
import "./DealerLoginPage.css";
import SEO from "../components/SEO/SEO";

export default function DealerLoginPage() {

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();


  const handleLogin = async (e) => {

    e.preventDefault();


    if (!phone || !password) {

      setError("Please enter phone number and password");
      return;

    }


    try {

      setLoading(true);
      setError("");


      const res = await http.post(
        "/api/dealers/login",
        {
          phone,
          password
        }
      );


      localStorage.setItem(
        "dealerToken",
        res.data.token
      );


      localStorage.setItem(
        "dealer",
        JSON.stringify(res.data.dealer)
      );


      navigate("/dealer/dashboard");


    } catch(err) {


      setError(
        err.response?.data?.error ||
        "Invalid login credentials"
      );


    } finally {

      setLoading(false);

    }

  };



  return (
<>
<SEO
    title="Dealer Login | BuildNear"
    description="Dealer Login"
    noIndex={true}
/>

    <div className="dealer-login-page">


      <div className="dealer-login-background">

        <div className="construction-shape shape-one"></div>
        <div className="construction-shape shape-two"></div>


      </div>



      <motion.div

        className="dealer-login-card"

        initial={{
          opacity:0,
          y:40
        }}

        animate={{
          opacity:1,
          y:0
        }}

        transition={{
          duration:.5
        }}

      >


        <div className="dealer-login-header">


          <img
            src="/images/logo/buildnear-logo-3d-512.png"
            alt="BuildNear"
          />


          <h2>
            Dealer Login
          </h2>


          <p>
            Access your BuildNear business dashboard
          </p>


        </div>




        <form onSubmit={handleLogin}>


          <div className="input-group">


            <label>
              Phone Number
            </label>


            <input

              type="text"

              placeholder="Enter registered phone"

              value={phone}

              onChange={
                e=>setPhone(e.target.value)
              }

            />


          </div>




          <div className="input-group">


            <label>
              Password
            </label>


            <input

              type="password"

              placeholder="Enter password"

              value={password}

              onChange={
                e=>setPassword(e.target.value)
              }

            />


          </div>




          {
            error &&

            <div className="login-error">

              {error}

            </div>

          }





          <button
            disabled={loading}
          >

            {
              loading
              ?
              "Logging in..."
              :
              "Login"
            }


          </button>



        </form>




        <div className="dealer-register-link">

          New dealer?

          <span
            onClick={() =>
              navigate("/dealer/register")
            }
          >
            Register here
          </span>


        </div>



      </motion.div>


    </div>
            </>
  );

}